import React from 'react';
import ComingSoon from '../components/ComingSoon';

const CreativeLeadership = () => <ComingSoon title="360º Creative Leadership" />;

export default CreativeLeadership;
